export default {
  welcomes: [],
  selectedWelcomeUser: null,
  error: false,
  errorMessage: '',
}